<template>
  <v-dialog
    v-model="dialog_confirmacao"
    width="360"
    persistent
    content-class="bar-12"
    transition="dialog-top-transition"
  >
    <template #activator="{on, attrs}">
      <v-autocomplete
        ref="inputMudarDepartamento"
        :items="departamentos_pendente_compra"
        item-text="descricao_completa"
        item-value="iddepartamento"
        hide-details
        class="ml-5"
        outlined
        flat
        solo-inverted
        dense
        :background-color="data_table_departamentos_carregando_dados ? '#f6f5f5' : '#FFFFFF'"
        :disabled="data_table_departamentos_carregando_dados || dialog_confirmacao"
        append-icon=""
        @focus="verificarCategoriasPendentesCompra"
        @change="irParaOutroDepartamento"
        @blur="confirmacao_troca_categoria = false"
      >
        <template #label>
          <span class="text-gray-300">Buscar outro departamento</span>
        </template>

        <template #selection="item">
          <span class="text-gray-300">{{ item }}</span>
        </template>

        <template #prepend-inner>
          <v-icon color="#777777" size="28">mdi-magnify</v-icon>
        </template>
      </v-autocomplete>
    </template>

    <v-card>
      <v-card-title class="justify-center pb-0">
        <p class="font-20 text-center">Mudar de departamento?</p>
      </v-card-title>

      <v-card-text>
        <p id="conteudo">
          Há <span class="font-weight-bold" v-text="CATEGORIAS_PENDENTES.length" />
          categorias pendentes de análise no departamento
          <span class="font-weight-bold" v-text="DEPARTAMENTO_COMPRA.descricao_departamento || ''" />.
          Deseja realmente ir para outro departamento?
        </p>
      </v-card-text>

      <v-card-actions class="justify-center mt-n4" style="border: 0">
        <div style="width: 312px" class="text-center justify-center">
          <SysBotao
            class="mb-2 w-full"
            color-texto="white"
            background="#142454"
            @click="dialog_confirmacao = false"
          >
            <span v-text="'Ficar e analisar'" class="font-16" />
          </SysBotao>

          <SysBotao class="w-full" @click="confirmarMudancaDepartamento">
            Ir para próximo departamento
          </SysBotao>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import SysBotao from "../../utils/botoes/SysBotao";
import {buscarDepartamentosEmGatilhoCompra} from "../../../api/compraPorDepartamentos/Departamento.js";
import {logout} from "../../../helpers";
import {parametros_rota} from "./helpers/ParametrosRota";
import {card_selecionado} from "./helpers/CardSelecionado";
import {data_table_departamentos_carregando_dados} from "../../utils/dataTable/sysDataTableDepartamentos/CarregandoDados.js";

export default {
  name: "MudarDeDepartamentoDialog",
  mixins: [parametros_rota,card_selecionado, data_table_departamentos_carregando_dados],
  components: {SysBotao},
  data: () => ({
    dialog_confirmacao: false,
    departamentos_pendente_compra: [],
    confirmacao_troca_categoria: false
  }),
  computed: {
    CATEGORIAS_PENDENTES() {
      return this.$store.getters["comprasPorDepartamentos/categorias_pendentes_compra"];
    },
    DEPARTAMENTO_COMPRA() {
      return this.$store.getters["comprasPorDepartamentos/departamento_compra"];
    }
  },
  created() {
    this.buscarDepartamentosPorCompra();
  },
  methods: {
    irParaOutroDepartamento(proximo_departamento) {
      this.departamento_compra = proximo_departamento;
      this.confirmacao_troca_categoria = false;
      this.$refs.inputMudarDepartamento.blur()
      this.setDepartamentosPendentes(this.departamentos_pendente_compra);
    },
    buscarDepartamentosPorCompra() {
      this.$store.dispatch("loading/addRequisicao",
        buscarDepartamentosEmGatilhoCompra(this.grupo_compra)
          .then(this.setDepartamentosPendentes).catch(logout)
      );
    },
    setDepartamentosPendentes(departamentos) {
      const callback = dep => `${dep.iddepartamento}` !== `${this.departamento_compra}`;
      this.departamentos_pendente_compra = departamentos.filter(callback);
    },
    verificarCategoriasPendentesCompra() {
      if (this.card_selecionado.chave !== 'itens_a_comprar') return;

      if (this.CATEGORIAS_PENDENTES.length > 0 && !this.confirmacao_troca_categoria) {
        this.dialog_confirmacao = true;
      }
    },
    confirmarMudancaDepartamento() {
      this.dialog_confirmacao = false;
      this.confirmacao_troca_categoria = true;
      setTimeout(() => this.$refs.inputMudarDepartamento.$refs.input.click(), 50);
    }
  }
}
</script>

<style scoped>
#conteudo {
  font-size: 16px;
  text-align: center;
  color: #282727;
}
</style>
